export default {
  data() {
    return {
      refDialogo: "refDialogo"
    };
  },

  methods: {
    getDialogoFormulario() {
      return this.$refs[this.refDialogo];
    },

    open(form = {}) {
      this.getDialogoFormulario().open(form);
    },

    cancel() {
      this.getDialogoFormulario().cancel();
    }
  }
};
